import { PALETTE } from '../../../../../../../src/constants';

export default {
  label: {
    color: PALETTE.secondaryText,
  },
  tickLabel: {
    color: PALETTE.secondaryText,
  },
  title: {
    color: PALETTE.secondaryText,
  },
  yAxis: {
    stroke: PALETTE.lineChartAxisColor,
  },
  xAxis: {
    stroke: PALETTE.lineChartAxisColor,
    strokeWidth: 2,
  },
  xAxisSmall: {
    stroke: PALETTE.lineChartAxisColor,
    strokeWidth: 1,
  },
  grid: {
    color: PALETTE.lineChartGridColor,
  },
  numberScale:{
    position: 'absolute',
    top: 44,
    fontSize:12,
    left: 53,
    color: PALETTE.secondaryText,
  }
};
